<template>
    <v-btn
        class="dropdown-icon"
        :class="style"
        @click="onClick"
        depressed
        color="transparent"
    >
        <v-icon >{{ value ? 'fas fa-caret-up' : 'fas fa-caret-down' }}</v-icon>
    </v-btn>
</template>

<script>
export default {
    name: "VDropdownButton",
    props: {
        value: {
            required: true
        },
        color: {
            required: false,
            default: function () {
                return 'primary--text';
            }
        },
        background: {
            required: false,
            default: function () {
                return 'white';
            }
        }
    },

    data: () => ({
        menuOpen: false,
    }),

    mounted() {
        this.menuOpen = this.value;
    },

    computed: {
        style () {
           return this.background + " " + this.color;
        }
    },

    methods: {
        onClick () {
            this.menuOpen = !this.menuOpen;
            this.$emit("input", this.menuOpen);
        }
    }
}
</script>

<style scoped>
.dropdown-icon {
    padding: 0!important;
    min-width: 16px!important;
    max-height: 15px;
    justify-content: end;
    border-radius: unset;
    margin-top: 2px;
}

.dropdown-icon i {
    font-size: 15pt!important;
    padding-left: 2px;
}

::v-deep .dropdown-icon .v-btn:hover:before {
    opacity: 0;
}
</style>